import { getAllPharmacons } from "../../../services/PharmaconService";
import useResources from "../../../hooks/UseResources";

export default function usePharmacons() {
    return useResources(getAllPharmacons, "data");
}
